export default "__VITE_ASSET__DgCjLw8Q__"